import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Input, Modal, Select, Spin } from "antd";
import React, { useState } from "react";
import CreatePlanAttributeApi from "../../../api/attributes/CreatePlanAttributeApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";

const { Option } = Select;

function AddPlanAttributeModal(props) {
  const [submit, setSubmit] = useState(false);

  function handleCancel() {
    setSubmit(false);
    props.handleCancel();
  }

  async function onFinish(values) {
    setSubmit(true);
    const apiResponse = await CreatePlanAttributeApi(
      values.name,
      values.valueType
    );
    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess(
        "bottomRight",
        "Plan attribute added successfully"
      );
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't add plan attribute. Try again later."
      );
    }
    handleCancel();
  }

  return (
    <Modal
      title="Add plan attribute"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="planGroup"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        requiredMark={false}
      >
        <Form.Item
          label="Attribute name*"
          name="name"
          rules={[
            { required: true, message: "Please enter a Attribute name!" },
          ]}
        >
          <Input placeholder="Name" />
        </Form.Item>

        <Form.Item
          label="Value type*"
          name="valueType"
          rules={[{ required: true, message: "Please select a Value type!" }]}
        >
          <Select
            allowClear
            showSearch
            placeholder="Select type"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            <Option key={"text"} value={"text"}>
              Text
            </Option>
            <Option key={"number"} value={"number"}>
              Number
            </Option>
            <Option key={"double"} value={"double"}>
              Double
            </Option>
            <Option key={"date"} value={"date"}>
              Date
            </Option>
            <Option key={"dropdown"} value={"dropdown"}>
              Dropdown
            </Option>
          </Select>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-32"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Add"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddPlanAttributeModal;
